/** @format */
import { FileUploadCustomCard } from '../botcustomcards/fileUploadCustomCard';
import React, { useEffect, useMemo, useState } from 'react';
// function attachmentMiddlewareWithDL(dl:any) {
//   return function () { }
// }

interface FileUploadCardContent {
  Title: string;
  Subtitle: string;
  VariableName: string;
}

// This middleware just changes the name of the attachement type as means of ensuring compatibility
////const attachmentMiddleware /*: OneOrMany<AttachmentMiddleware.ActivityMiddleware> */ =
//const attachmentMiddleware /*: OneOrMany<AttachmentMiddleware.ActivityMiddleware> */ =
function attachmentMiddlewareWithDL(dl: any) {
  return function () {
    return function (next: any) {
      return function (card: any) {
        //console.log('incomingcard: ' + JSON.stringify(card));
        //console.log('fucc1: ' + JSON.stringify(card?.attachment?.content));
        //console.log('fucc2: ' + JSON.stringify(card?.content));
        //console.log('incoming attachment: ' + card?.attachment?.contentType);

        //let fucc = (FileUploadCardContent)card?.content;
        switch (card.attachment.contentType) {
          case 'application/vnd.microsoft.card.custom.fileuploadcard':
            return (
              // <div>
              //   <button>upload</button>test
              // </div>
              <FileUploadCustomCard
                Directline={dl}
                Title={card?.attachment?.content.Title}
                SubTitle={card?.attachment?.content.Subtitle}
                Variable={card?.attachment?.content.VariableName}
              ></FileUploadCustomCard>
            );
          case 'application/vnd.microsoft.card.custom':
            card.attachment.contentType =
              'application/vnd.microsoft.card.adaptive';
            return next(card);

          default:
            return next(card);
        }
        // if (
        //   card?.attachment?.contentType ===
        //   'application/vnd.microsoft.card.custom'
        // ) {
        //   // card.attachment.contentType =
        //   //   'application/vnd.microsoft.card.adaptive';
        //   //console.log('********* customcards encountered ***********');
        //   //console.log(card?.attachment?.contentType);
        //   //console.log(card?.attachment?.content);
        // } else {
        //   return next(card);
        // }
        // if (
        //   card?.attachment?.contentType ===
        //   'application/vnd.microsoft.card.custom.fileuploadcard'
        //   //application/vnd.microsoft.card.custom.fileuploadcard
        // ) {
        //   //console.log('*************** FILEUPLOADCARD ********************');
        //   //console.log(card?.attachment?.contentType);
        //   //console.log(card?.attachment?.content);
        //   return <div>flieuploadtest</div>;
        // }
      };
    };
  };
}

export default attachmentMiddlewareWithDL;
